import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";

// Import components


// Import pages
import HomePage from "./pages/HomePage";
import Customer from "./pages/Cutomer";


function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        {/* <Header /> */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/customer" element={<Customer />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
